import * as React from 'react';
import { memo } from 'react';

import { CommonHelper } from 'components/Common/Helper/Helper';

import getFieldLabelTranslationArgs from './getFieldLabelTranslationArgs';

export const FieldTitle = ({
    resource,
    source,
    label,
    isRequired,
}) => {
    const translate = (trans) => CommonHelper.GetTrans(trans);
    if (label && typeof label !== 'string') {
        return label;
    }
    return (
        <span>
            {translate(
                ...getFieldLabelTranslationArgs({
                    label,
                    resource,
                    source,
                })
            )}
            {isRequired && ' *'}
        </span>
    );
};

// wat? TypeScript looses the displayName if we don't set it explicitly
FieldTitle.displayName = 'FieldTitle';

export default memo(FieldTitle);
